// ═══════════════════════════════════════════════════════════════════════════════
// Helper — future task date range & early submit window (tomorrow … today+3)
// ═══════════════════════════════════════════════════════════════════════════════

export const HELPER_FUTURE_MAX_DAYS_FROM_TODAY = 3;

export const addCalendarDaysToYmd = (ymd: string, deltaDays: number): string => {
  const [yRaw, mRaw, dRaw] = ymd.split('-');
  const y = Number(yRaw);
  const m = Number(mRaw);
  const d = Number(dRaw);
  const base = new Date(y, m - 1, d);
  base.setDate(base.getDate() + deltaDays);
  const yy = base.getFullYear();
  const mm = String(base.getMonth() + 1).padStart(2, '0');
  const dd = String(base.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
};

export const diffCalendarDaysYmd = (fromYmd: string, toYmd: string): number => {
  const [fy, fm, fd] = fromYmd.split('-').map(Number);
  const [ty, tm, td] = toYmd.split('-').map(Number);
  const fromUtc = Date.UTC(fy, fm - 1, fd);
  const toUtc = Date.UTC(ty, tm - 1, td);
  return Math.round((toUtc - fromUtc) / 86_400_000);
};

export const getHelperFutureTomorrowYmd = (todayYmd: string): string =>
  addCalendarDaysToYmd(todayYmd, 1);

export const getHelperFutureMaxEndYmd = (todayYmd: string): string =>
  addCalendarDaysToYmd(todayYmd, HELPER_FUTURE_MAX_DAYS_FROM_TODAY);

export const isHelperFutureDueDate = (dueDateYmd: string, todayYmd: string): boolean =>
  dueDateYmd > todayYmd;

export const isWithinHelperEarlySubmitRange = (
  dueDateYmd: string,
  todayYmd: string,
): boolean => {
  if (dueDateYmd <= todayYmd) {
    return true;
  }
  const tomorrowYmd = getHelperFutureTomorrowYmd(todayYmd);
  const maxYmd = getHelperFutureMaxEndYmd(todayYmd);
  return dueDateYmd >= tomorrowYmd && dueDateYmd <= maxYmd;
};

export const formatMonthDayFromYmd = (dueDateYmd: string): string => {
  const tail = dueDateYmd.slice(5);
  if (tail.length !== 5 || dueDateYmd[4] !== '-') {
    return '';
  }
  return tail;
};
